import React from 'react';
import PropTypes from 'prop-types';
import clasnames from 'classnames';
import { Events, triggerMixPanelEvent } from '../../../lib/mixpanelEvents';

export default function Skill({ skill }) {
    const {
        name,
        url,
        verified
    } = skill;

    const clasName = clasnames({ verified });

    return (
        <li className={clasName}>
            <a href={url} onClick={() => triggerMixPanelEvent(Events.GeneralEvents.TAG_CLICKED, {}, {'Tag name': name})}>{name}</a>
        </li>
    );
}

Skill.propTypes = {
    skill: PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
        verified: PropTypes.bool
    })
};

Skill.defaultProps = {
    skill: {}
};
